/*!
 * Copyright (c) 2026 Elevation Technologies Pte Ltd.
 * Developer: filimoni@elevationtech.com.fj
 */
import React, { useState } from 'react';
import PhotoLightbox from '../components/PhotoLightbox';
import { ETHICS_PHOTOS } from '../data/siteData';

export function EthicsCopy({ html, className = '' }) {
  if (!html) {
    return null;
  }

  return (
    <section className={`fsf-ethics-copy ${className}`.trim()}>
      <div className="fsf-ethics-copy__inner" dangerouslySetInnerHTML={{ __html: html }} />
    </section>
  );
}

export function EthicsVisual({ photo, index, onOpen, className = '', loading = 'lazy' }) {
  if (!photo?.src) {
    return null;
  }

  return (
    <figure className={`fsf-ethics-visual ${className}`.trim()}>
      <button
        className="fsf-ethics-photo-button"
        type="button"
        onClick={() => onOpen(index)}
        aria-label={`Open ${photo.alt}`}
      >
        <img src={photo.src} alt={photo.alt} loading={loading} />
      </button>
    </figure>
  );
}

export default function EthicsPageSections({ page }) {
  const [activePhotoIndex, setActivePhotoIndex] = useState(null);
  const copyBlocks = (page.blocks || []).filter((block) => block?.type === 'html');

  return (
    <>
      <div className="fsf-ethics-story">
        <EthicsCopy html={copyBlocks[0]?.html} className="fsf-ethics-copy--intro" />

        <section className="fsf-ethics-values" aria-label="Freight Services Fiji values and culture">
          <EthicsVisual
            photo={ETHICS_PHOTOS[0]}
            index={0}
            onOpen={setActivePhotoIndex}
            className="fsf-ethics-visual--center"
            loading="eager"
          />
          <EthicsVisual
            photo={ETHICS_PHOTOS[1]}
            index={1}
            onOpen={setActivePhotoIndex}
            className="fsf-ethics-visual--wide"
            loading="eager"
          />
          <EthicsVisual
            photo={ETHICS_PHOTOS[2]}
            index={2}
            onOpen={setActivePhotoIndex}
            className="fsf-ethics-visual--wide"
          />
          <EthicsVisual
            photo={ETHICS_PHOTOS[3]}
            index={3}
            onOpen={setActivePhotoIndex}
            className="fsf-ethics-visual--wide fsf-ethics-visual--compact"
          />
          <EthicsVisual
            photo={ETHICS_PHOTOS[4]}
            index={4}
            onOpen={setActivePhotoIndex}
            className="fsf-ethics-visual--center"
          />
        </section>

        <EthicsCopy html={copyBlocks[1]?.html} className="fsf-ethics-copy--closing" />
      </div>

      <PhotoLightbox
        images={ETHICS_PHOTOS}
        activeIndex={activePhotoIndex}
        setActiveIndex={setActivePhotoIndex}
        label="Freight Services Fiji values and culture photos"
      />
    </>
  );
}
